// src/data/CoursesData.js

// ============================================================
// ALL PITAC CENTRES
// ============================================================
export const centersData = [
  {
    id: 'head-office',
    name: 'PITAC Head Office Lahore',
    shortName: 'HQ Lahore',
    city: 'Lahore',
    province: 'Punjab',
    provinceCode: 'PUNJAB',
    address: '234-Ferozepur Road, near Metro Canal Station, Lahore 54600, Pakistan',
    phone: '+92 42 9923 0699',
    phone2: '+92 42 9923 0702',
    email: 'info@pitac.gov.pk',
    supportEmail: 'support@pitac.gov.pk',
    hours: 'Monday – Friday: 9:00 AM – 5:00 PM',
    hoursWeekend: 'Saturday – Sunday: Closed',
    coordinates: { lat: 31.5204, lng: 74.3587 },
    type: 'head-office',
    emoji: '🏛️',
    gradient: 'linear-gradient(135deg, #064e3b 0%, #0f7b3a 50%, #16a34a 100%)',
    facilities: ['Administration', 'Information Desk', 'Regional Coordination'],
    mapUrl: 'https://maps.google.com/?q=234+Ferozepur+Road+Lahore',
    social: {
      facebook: 'https://facebook.com/pitacpk',
      twitter: 'https://twitter.com/pitacpk',
      instagram: 'https://instagram.com/pitacpk',
      linkedin: 'https://linkedin.com/company/pitac'
    }
  },
  {
    id: 'quetta',
    name: 'PITAC Regional Centre Quetta',
    shortName: 'Quetta',
    city: 'Quetta',
    province: 'Balochistan',
    provinceCode: 'BALOCHISTAN',
    address: 'Industrial Estate, In-front of Utility Store Zonal Office, Sirki Road, Quetta',
    phone: '081-9211088',
    phone2: '+92 302 384-4602',
    email: 'Quetta@pitac.gov.pk',
    coordinates: { lat: 30.1798, lng: 66.9750 },
    type: 'regional',
    emoji: '🎓',
    gradient: 'linear-gradient(135deg, #0f7b3a 0%, #2e9e5a 100%)',
    facilities: [
      'Expert Trainers',
      'Hands-on Practice',
      'Modern Labs',
      'Government Certified',
      'Better Job Opportunities'
    ],
    mapUrl: 'https://maps.google.com/?q=PITAC+Regional+Centre+Quetta',
    social: {
      facebook: 'https://facebook.com/pitacquetta',
      twitter: 'https://twitter.com/pitacquetta',
      instagram: 'https://instagram.com/pitacquetta',
      linkedin: 'https://linkedin.com/company/pitac-quetta'
    }
  },
  {
    id: 'mirpur',
    name: 'PITAC Regional Centre Mirpur',
    shortName: 'Mirpur',
    city: 'Mirpur',
    province: 'Azad Jammu & Kashmir',
    provinceCode: 'AJK',
    address: 'House No. 141, Sector D-1, Allama Iqbal Road, Mirpur (AJK)',
    phone: '05827-920322',
    email: 'mirpur@pitac.gov.pk',
    coordinates: { lat: 33.1486, lng: 73.7513 },
    type: 'regional',
    emoji: '🎓',
    gradient: 'linear-gradient(135deg, #0f7b3a 0%, #2e9e5a 100%)',
    facilities: ['Modern Labs', 'Expert Trainers', 'Government Certified'],
    mapUrl: 'https://maps.google.com/?q=PITAC+Mirpur+AJK',
    social: {
      facebook: 'https://facebook.com/pitacmirpur',
      twitter: 'https://twitter.com/pitacmirpur',
      instagram: 'https://instagram.com/pitacmirpur',
      linkedin: 'https://linkedin.com/company/pitac-mirpur'
    }
  },
  {
    id: 'gilgit',
    name: 'PITAC Regional Centre Gilgit',
    shortName: 'Gilgit',
    city: 'Gilgit',
    province: 'Gilgit-Baltistan',
    provinceCode: 'GB',
    address: 'Building of Kashrote A Class Dispensary, Essan Ali Road, Kashrote, Gilgit (GB)',
    phone: '05811-942539',
    email: 'gilgit@pitac.gov.pk',
    coordinates: { lat: 35.9208, lng: 74.3144 },
    type: 'regional',
    emoji: '🎓',
    gradient: 'linear-gradient(135deg, #0f7b3a 0%, #2e9e5a 100%)',
    facilities: ['Modern Labs', 'Expert Trainers', 'Government Certified'],
    mapUrl: 'https://maps.google.com/?q=PITAC+Gilgit',
    social: {
      facebook: 'https://facebook.com/pitacgilgit',
      twitter: 'https://twitter.com/pitacgilgit',
      instagram: 'https://instagram.com/pitacgilgit',
      linkedin: 'https://linkedin.com/company/pitac-gilgit'
    }
  },
  {
    id: 'peshawar',
    name: 'PITAC Regional Centre Peshawar',
    shortName: 'Peshawar',
    city: 'Peshawar',
    province: 'Khyber Pakhtunkhwa',
    provinceCode: 'KPK',
    address: 'Inside Govt. College of Technology, Kohat Road, Peshawar (KPK)',
    phone: '091-9210976',
    email: 'peshawar@pitac.gov.pk',
    coordinates: { lat: 34.0151, lng: 71.5249 },
    type: 'regional',
    emoji: '🎓',
    gradient: 'linear-gradient(135deg, #0f7b3a 0%, #2e9e5a 100%)',
    facilities: ['Modern Labs', 'Expert Trainers', 'Government Certified'],
    mapUrl: 'https://maps.google.com/?q=PITAC+Peshawar',
    social: {
      facebook: 'https://facebook.com/pitacpeshawar',
      twitter: 'https://twitter.com/pitacpeshawar',
      instagram: 'https://instagram.com/pitacpeshawar',
      linkedin: 'https://linkedin.com/company/pitac-peshawar'
    }
  },
  {
    id: 'karachi',
    name: 'PITAC Regional Centre Karachi',
    shortName: 'Karachi',
    city: 'Karachi',
    province: 'Sindh',
    provinceCode: 'SINDH',
    address: 'House # 1/2 N, PECHS Block-06, Karachi (Sindh)',
    phone: '021-99333324',
    email: 'karachi@pitac.gov.pk',
    coordinates: { lat: 24.8607, lng: 67.0011 },
    type: 'regional',
    emoji: '🎓',
    gradient: 'linear-gradient(135deg, #0f7b3a 0%, #2e9e5a 100%)',
    facilities: ['Modern Labs', 'Expert Trainers', 'Government Certified'],
    mapUrl: 'https://maps.google.com/?q=PITAC+Karachi',
    social: {
      facebook: 'https://facebook.com/pitackarachi',
      twitter: 'https://twitter.com/pitackarachi',
      instagram: 'https://instagram.com/pitackarachi',
      linkedin: 'https://linkedin.com/company/pitac-karachi'
    }
  }
];

// ============================================================
// ALL COURSES — each tagged with centerId
// ============================================================
export const courseData = [
  // ============ HQ LAHORE COURSES ============
  // --- Designing (Mechanical) ---
  { id: 1, centerId: 'head-office', category: 'Designing (Mechanical)',
    name: 'ENGINEERING DRAFTING', duration: '6 Weeks', fee: '8,000',
    level: 'Beginner', icon: '📐', popular: false },
  { id: 2, centerId: 'head-office', category: 'Designing (Mechanical)',
    name: 'AUTOCAD MECHANICAL', duration: '6 Weeks', fee: '12,000',
    level: 'Beginner', icon: '📐', popular: true },
  { id: 3, centerId: 'head-office', category: 'Designing (Mechanical)',
    name: '3D CADCAM', duration: '6 Weeks', fee: '10,000',
    level: 'Intermediate', icon: '🖥️', popular: false },
  { id: 4, centerId: 'head-office', category: 'Designing (Mechanical)',
    name: 'SOLID WORKS', duration: '4 Weeks', fee: '12,000',
    level: 'Intermediate', icon: '🔧', popular: true },
  { id: 5, centerId: 'head-office', category: 'Designing (Mechanical)',
    name: 'Pro-E', duration: '4 Weeks', fee: '12,000',
    level: 'Intermediate', icon: '🔧', popular: false },
  { id: 6, centerId: 'head-office', category: 'Designing (Mechanical)',
    name: 'MOLD DESIGNING', duration: '6 Weeks', fee: '10,000',
    level: 'Advanced', icon: '⚙️', popular: false },
  { id: 7, centerId: 'head-office', category: 'Designing (Mechanical)',
    name: 'JIGS & FIXTURES DESIGNING', duration: '6 Weeks', fee: '10,000',
    level: 'Advanced', icon: '⚙️', popular: false },
  { id: 8, centerId: 'head-office', category: 'Designing (Mechanical)',
    name: 'PRESS TOOL DESIGN', duration: '6 Weeks', fee: '10,000',
    level: 'Advanced', icon: '⚙️', popular: false },
  { id: 9, centerId: 'head-office', category: 'Designing (Mechanical)',
    name: 'CUTTING TOOL DESIGN', duration: '6 Weeks', fee: '10,000',
    level: 'Advanced', icon: '⚙️', popular: false },

  // --- Mechanical Manufacturing ---
  { id: 10, centerId: 'head-office', category: 'Mechanical Manufacturing',
    name: 'CNC MACHINING CENTER', duration: '4 Weeks', fee: '10,000',
    level: 'Intermediate', icon: '🏭', popular: true },
  { id: 11, centerId: 'head-office', category: 'Mechanical Manufacturing',
    name: 'CNC TURNING CENTER', duration: '6 Weeks', fee: '10,000',
    level: 'Intermediate', icon: '🏭', popular: false },
  { id: 12, centerId: 'head-office', category: 'Mechanical Manufacturing',
    name: 'CNC EDM SINKER + WIRECUT', duration: '4 Weeks', fee: '8,000',
    level: 'Intermediate', icon: '🏭', popular: false },
  { id: 13, centerId: 'head-office', category: 'Mechanical Manufacturing',
    name: 'CNC INJECTION MOULDING', duration: '3 Weeks', fee: '8,000',
    level: 'Intermediate', icon: '🏭', popular: false },
  { id: 14, centerId: 'head-office', category: 'Mechanical Manufacturing',
    name: 'BASIC MACHINE SHOP', duration: '6 Weeks', fee: '8,000',
    level: 'Beginner', icon: '🔩', popular: false },
  { id: 15, centerId: 'head-office', category: 'Mechanical Manufacturing',
    name: 'DIE & MOLD MANUFACTURING', duration: '12 Weeks', fee: '14,500',
    level: 'Advanced', icon: '🏭', popular: true },
  { id: 16, centerId: 'head-office', category: 'Information Technology',
    name: 'Certificate in Information Technology (CIT)', duration: '6 Months', fee: '3,000',
    level: 'Beginner', icon: '🖥️', popular: true, certification: 'Government Certified' },
  { id: 17, centerId: 'head-office', category: 'Mechanical Manufacturing',
    name: 'COMPUTER FOUNDATION', duration: '6 Weeks', fee: '8,000',
    level: 'Beginner', icon: '💻', popular: false },
  { id: 18, centerId: 'head-office', category: 'Design',
    name: 'GRAPHIC DESIGN', duration: '12 Weeks', fee: '13,000',
    level: 'Intermediate', icon: '🎨', popular: true },

  // --- Civil ---
  { id: 19, centerId: 'head-office', category: 'Civil',
    name: 'QUANTITY SURVEYOR', duration: '6 Weeks', fee: '10,000',
    level: 'Intermediate', icon: '📊', popular: true },
  { id: 20, centerId: 'head-office', category: 'Civil',
    name: 'AUTOCAD CIVIL', duration: '6 Weeks', fee: '10,000',
    level: 'Beginner', icon: '📐', popular: false },
  { id: 21, centerId: 'head-office', category: 'Civil',
    name: 'QUANTITY SURVEYOR + AUTOCAD CIVIL', duration: '8 Weeks', fee: '15,000',
    level: 'Intermediate', icon: '📊', popular: false },
  { id: 22, centerId: 'head-office', category: 'Civil',
    name: 'PLUMBER & PIPE TECHNICIAN', duration: '6 Weeks', fee: '8,000',
    level: 'Beginner', icon: '🔧', popular: false },
  { id: 23, centerId: 'head-office', category: 'Civil',
    name: 'QA / QC', duration: '6 Weeks', fee: '10,000',
    level: 'Intermediate', icon: '✅', popular: false },
  { id: 24, centerId: 'head-office', category: 'Civil',
    name: 'INSPECTION & MEASURING TECHNIQUE', duration: '6 Weeks', fee: '8,000',
    level: 'Intermediate', icon: '📏', popular: false },
  { id: 25, centerId: 'head-office', category: 'Civil',
    name: 'CMM - COORDINATE MEASURING MACHINE', duration: '4 Weeks', fee: '8,000',
    level: 'Intermediate', icon: '📏', popular: false },
  { id: 26, centerId: 'head-office', category: 'Civil',
    name: 'QUALITY INSPECTOR', duration: '6 Weeks', fee: '12,000',
    level: 'Intermediate', icon: '✅', popular: false },
  { id: 27, centerId: 'head-office', category: 'Civil',
    name: 'CALIBRATION LABORATORY TECHNICIAN', duration: '2 Weeks', fee: '10,000',
    level: 'Advanced', icon: '🔬', popular: false },

  // --- Welding & Fabrication ---
  { id: 28, centerId: 'head-office', category: 'Welding & Fabrication',
    name: 'BASIC WELDING', duration: '6 Weeks', fee: '8,000',
    level: 'Beginner', icon: '🔥', popular: true },
  { id: 29, centerId: 'head-office', category: 'Welding & Fabrication',
    name: 'TIG WELDING', duration: '4 Weeks', fee: '10,000',
    level: 'Intermediate', icon: '🔥', popular: false },
  { id: 30, centerId: 'head-office', category: 'Welding & Fabrication',
    name: 'MIG WELDING', duration: '4 Weeks', fee: '10,000',
    level: 'Intermediate', icon: '🔥', popular: false },
  { id: 31, centerId: 'head-office', category: 'Welding & Fabrication',
    name: '6G MULTI WELDING', duration: '4 Weeks', fee: '28,000',
    level: 'Advanced', icon: '🔥', popular: true },
  { id: 32, centerId: 'head-office', category: 'Welding & Fabrication',
    name: 'NDT LEVEL 1', duration: '1 Week', fee: '25,000',
    level: 'Beginner', icon: '🔍', popular: false },
  { id: 33, centerId: 'head-office', category: 'Welding & Fabrication',
    name: 'NDT LEVEL 2', duration: '1 Week', fee: '25,000',
    level: 'Intermediate', icon: '🔍', popular: false },
  { id: 34, centerId: 'head-office', category: 'Welding & Fabrication',
    name: 'REFRIGERATION AND AIR CONDITIONING (RAC)', duration: '8 Weeks', fee: '10,500',
    level: 'Intermediate', icon: '❄️', popular: true },

  // --- Electrical & Electronics ---
  { id: 35, centerId: 'head-office', category: 'Electrical & Electronics',
    name: 'INDUSTRIAL ELECTRICIAN', duration: '8 Weeks', fee: '10,500',
    level: 'Beginner', icon: '⚡', popular: true },
  { id: 36, centerId: 'head-office', category: 'Electrical & Electronics',
    name: 'AUTOCAD ELECTRICAL', duration: '6 Weeks', fee: '10,000',
    level: 'Beginner', icon: '⚡', popular: false },
  { id: 37, centerId: 'head-office', category: 'Electrical & Electronics',
    name: 'PLC-HMI', duration: '12 Weeks', fee: '21,000',
    level: 'Advanced', icon: '🤖', popular: true },
  { id: 38, centerId: 'head-office', category: 'Electrical & Electronics',
    name: 'INSTRUMENTATION & PROCESS CONTROL', duration: '6 Weeks', fee: '10,000',
    level: 'Intermediate', icon: '📊', popular: false },

  // --- Language ---
  { id: 39, centerId: 'head-office', category: 'Language',
    name: 'SPOKEN ENGLISH', duration: '6 Weeks', fee: '8,000',
    level: 'Beginner', icon: '🗣️', popular: true },
  { id: 40, centerId: 'head-office', category: 'Language',
    name: 'ENGLISH GRAMMAR', duration: '6 Weeks', fee: '8,000',
    level: 'Beginner', icon: '📖', popular: false },
  { id: 41, centerId: 'head-office', category: 'Language',
    name: 'IELTS PREPARATION', duration: '6 Weeks', fee: '15,000',
    level: 'Intermediate', icon: '🎓', popular: true },

  // --- Health & Safety ---
  { id: 42, centerId: 'head-office', category: 'Health & Safety',
    name: 'SAFETY & HEALTH OFFICER', duration: '6 Weeks', fee: '15,000',
    level: 'Intermediate', icon: '🦺', popular: true },

  // --- EV ---
  { id: 43, centerId: 'head-office', category: 'EV',
    name: 'EV TECHNICIAN', duration: '4 Weeks', fee: '12,000',
    level: 'Intermediate', icon: '🔋', popular: true },

  // --- AI & Technology ---
  { id: 44, centerId: 'head-office', category: 'AI & Technology',
    name: 'NETWORKING & CLOUD COMPUTING', duration: '3 Months', fee: '25,000',
    level: 'Intermediate', icon: '☁️', popular: true, certification: 'Government Certified' },
  { id: 45, centerId: 'head-office', category: 'AI & Technology',
    name: 'MACHINE LEARNING & DEEP LEARNING', duration: '3 Months', fee: '25,000',
    level: 'Advanced', icon: '🧠', popular: true, certification: 'Government Certified' },
  { id: 46, centerId: 'head-office', category: 'AI & Technology',
    name: 'WEB DEVELOPMENT WITH PYTHON AI', duration: '6 Months', fee: '30,000',
    level: 'Advanced', icon: '🌐', popular: true, certification: 'Government Certified' },
  { id: 47, centerId: 'head-office', category: 'AI & Technology',
    name: 'AI BASED GRAPHIC DESIGNING', duration: '3 Months', fee: '33,000',
    level: 'Advanced', icon: '🎨', popular: false, certification: 'Government Certified' },
  { id: 48, centerId: 'head-office', category: 'AI & Technology',
    name: 'CYBER SECURITY', duration: '3 Months', fee: '42,000',
    level: 'Advanced', icon: '🔒', popular: true, certification: 'Government Certified' },
  { id: 49, centerId: 'head-office', category: 'AI & Technology',
    name: 'SHOPIFY AI MASTERY BOOTCAMP', duration: '3 Months', fee: '37,500',
    level: 'Advanced', icon: '🛒', popular: false, certification: 'Government Certified' },
  { id: 50, centerId: 'head-office', category: 'AI & Technology',
    name: 'DIGITAL MEDIA MARKETING & ANALYTICS', duration: '3 Months', fee: '33,000',
    level: 'Intermediate', icon: '📊', popular: true, certification: 'Government Certified' },
  { id: 51, centerId: 'head-office', category: 'AI & Technology',
    name: 'ARTIFICIAL INTELLIGENCE BOOTCAMP', duration: '4 Months', fee: '60,000',
    level: 'Advanced', icon: '🤖', popular: true, certification: 'Government Certified' },
  { id: 52, centerId: 'head-office', category: 'AI & Technology',
    name: 'VIDEO EDITING & YOUTUBE', duration: '3 Months', fee: '37,500',
    level: 'Intermediate', icon: '🎬', popular: true, certification: 'Government Certified' },
  { id: 53, centerId: 'head-office', category: 'AI & Technology',
    name: 'WEB DEVELOPMENT', duration: '3 Months', fee: '33,000',
    level: 'Intermediate', icon: '🌐', popular: true, certification: 'Government Certified' },
  { id: 54, centerId: 'head-office', category: 'AI & Technology',
    name: 'AMAZON', duration: '3 Months', fee: '37,500',
    level: 'Intermediate', icon: '📦', popular: false, certification: 'Government Certified' },

  // --- Foundry & Metal Treatment ---
  { id: 55, centerId: 'head-office', category: 'Foundry & Metal Treatment',
    name: 'FOUNDRY TECHNIQUES', duration: '6 Weeks', fee: '8,000',
    level: 'Beginner', icon: '🏭', popular: false },
  { id: 56, centerId: 'head-office', category: 'Foundry & Metal Treatment',
    name: 'HEAT TREATMENT TECHNIQUES', duration: '6 Weeks', fee: '8,000',
    level: 'Intermediate', icon: '🔥', popular: false },

  // --- Pattern, Carpenter & CNC Wood Router ---
  { id: 57, centerId: 'head-office', category: 'Pattern, Carpenter & CNC Wood Router',
    name: 'PATTERN MAKING', duration: '6 Weeks', fee: '8,000',
    level: 'Beginner', icon: '🪵', popular: false },
  { id: 58, centerId: 'head-office', category: 'Pattern, Carpenter & CNC Wood Router',
    name: 'CARPENTER', duration: '12 Weeks', fee: '20,000',
    level: 'Intermediate', icon: '🪚', popular: false },
  { id: 59, centerId: 'head-office', category: 'Pattern, Carpenter & CNC Wood Router',
    name: 'CNC WOOD ROUTER', duration: '2 Weeks', fee: '10,000',
    level: 'Beginner', icon: '🪵', popular: false },

  // --- Renewable Energy (Solar) ---
  { id: 60, centerId: 'head-office', category: 'Renewable Energy (Solar)',
    name: 'SOLAR SYSTEM DESIGNING & INSTALLATION', duration: '4 Weeks', fee: '10,000',
    level: 'Intermediate', icon: '☀️', popular: true, certification: 'Government Certified' },

  // ============ QUETTA COURSES ============
  { id: 101, centerId: 'quetta', category: 'Information Technology',
    name: 'Advance Certificate in Information Technology (ACIT)',
    duration: '1 Year', fee: '6,000', level: 'Advanced', icon: '💻',
    popular: true, certification: 'Government Certified',
    outline: ['Basic Computer','Operating System (Windows 10)','Microsoft Office 2021',
      'Hardware & Installation','Graphic Designing','Video Editing',
      'Advance Internet','PHP / Laravel','XAMPP (MySQL)'] },
  { id: 102, centerId: 'quetta', category: 'Information Technology',
    name: 'Certificate in Information Technology (CIT)',
    duration: '6 Months', fee: '3,000', level: 'Beginner', icon: '🖥️',
    popular: true, certification: 'Government Certified',
    outline: ['Basic Computer','Operating System (Windows 10)','Microsoft Office 2021',
      'Hardware & Installation','Urdu Inpage','Internet/Basic Networking','Typing'] },
  { id: 103, centerId: 'quetta', category: 'Networking',
    name: 'CISCO Certified Network Associate (CCNA)',
    duration: '3 Months', fee: '5,000', level: 'Intermediate', icon: '🌐',
    popular: true, certification: 'CISCO Certified',
    outline: ['IPv4 Subnetting & IPv6','Router Configuration (Cisco CLI)',
      'VLAN, NAT & PAT','DHCP Server & IP Management',
      'Access Control Lists','SSH Remote Access','Network Automation Basics'] },
  { id: 104, centerId: 'quetta', category: 'Technical',
    name: 'CCTV Technician', duration: '3 Weeks', fee: '4,000',
    level: 'Beginner', icon: '📹', popular: false, certification: 'Government Certified',
    outline: ['Introduction to CCTV','Camera Types & Selection','DVR / NVR',
      'Cabling & Connectivity','Installation & Mounting','Configuration & Setup',
      'Troubleshooting'] },
  { id: 105, centerId: 'quetta', category: 'Marketing',
    name: 'Digital Media Marketing', duration: '3 Months', fee: '5,000',
    level: 'Intermediate', icon: '📱', popular: true, certification: 'Government Certified',
    outline: ['Brand Building','Digital Marketing','Graphic Design','Video Editing',
      'Marketing Strategy','Social Media Marketing','Facebook / Instagram Ads','Google Ads'] },
  { id: 106, centerId: 'quetta', category: 'Design',
    name: 'Graphic Designing UI/UX', duration: '3 Months', fee: '3,500',
    level: 'Intermediate', icon: '🎨', popular: true, certification: 'Government Certified',
    outline: ['Intro to Graphics Design','Exploring Canva','Basic Design Tools & Rules',
      'Logos, Flyers & Advert Posts','Business Cards & Profiles',
      'Monetisation of Design Skills'] },
  { id: 107, centerId: 'quetta', category: 'Technical',
    name: 'Mobile Phone Repairing', duration: '3 Months', fee: '6,000',
    level: 'Beginner', icon: '📱', popular: false, certification: 'Government Certified',
    outline: ['Introduction','Tools & Equipment','Mobile Components',
      'Basic Electronics','Disassembly & Reassembly','Troubleshooting',
      'Soldering Techniques','Practical Training'] },
  { id: 108, centerId: 'quetta', category: 'Electrical',
    name: 'General Electrician Course', duration: '3 Months', fee: '6,000',
    level: 'Beginner', icon: '⚡', popular: true, certification: 'Government Certified',
    outline: ['Basic Electrical Theory','Tools & Safety','Wiring Systems',
      'Domestic Installation','Fault Finding','Motors & Machines','Earthing & Protections'] },
  { id: 109, centerId: 'quetta', category: 'Electrical',
    name: 'Solar & UPS Technician Course', duration: '3 Months', fee: '6,000',
    level: 'Intermediate', icon: '☀️', popular: true, certification: 'Government Certified',
    outline: ['Basic Electrical Knowledge','Components (MCB, Breaker, Fuse)',
      'Solar Energy Basics','Load Calculation','Troubleshooting',
      'Practical Installation'] },
  { id: 110, centerId: 'quetta', category: 'Information Technology',
    name: 'Web Development Course', duration: '3 Months', fee: '6,000',
    level: 'Intermediate', icon: '🌐', popular: true, certification: 'Government Certified',
    outline: ['HTML','CSS','Bootstrap','PHP (Laravel)','XAMPP'] },
  { id: 111, centerId: 'quetta', category: 'Information Technology',
    name: 'Python Programming', duration: '6 Months', fee: '6,000',
    level: 'Intermediate', icon: '🐍', popular: true, certification: 'Government Certified',
    outline: ['Python Basics','Operators & Expressions','Conditional Statements',
      'Loops','Functions & Modules','Data Structures','File Handling',
      'OOP','Database Connectivity','NumPy / Pandas / Matplotlib'] },

  // ============ MIRPUR ============
  { id: 201, centerId: 'mirpur', category: 'Information Technology',
    name: 'Certificate in Information Technology (CIT)', duration: '6 Months',
    fee: '3,000', level: 'Beginner', icon: '🖥️', popular: true, certification: 'Government Certified' },
  { id: 202, centerId: 'mirpur', category: 'Information Technology',
    name: 'Web Development', duration: '3 Months', fee: '6,000',
    level: 'Intermediate', icon: '🌐', popular: true, certification: 'Government Certified' },
  { id: 203, centerId: 'mirpur', category: 'Design',
    name: 'Graphic Designing', duration: '3 Months', fee: '5,000',
    level: 'Beginner', icon: '🎨', popular: false, certification: 'Government Certified' },
  { id: 204, centerId: 'mirpur', category: 'Technical',
    name: 'Mobile Phone Repairing', duration: '3 Months', fee: '6,000',
    level: 'Beginner', icon: '📱', popular: true, certification: 'Government Certified' },
  { id: 205, centerId: 'mirpur', category: 'Electrical',
    name: 'General Electrician', duration: '3 Months', fee: '6,000',
    level: 'Beginner', icon: '⚡', popular: false, certification: 'Government Certified' },

  // ============ GILGIT ============
  { id: 301, centerId: 'gilgit', category: 'Information Technology',
    name: 'Certificate in Information Technology (CIT)', duration: '6 Months',
    fee: '3,000', level: 'Beginner', icon: '🖥️', popular: true, certification: 'Government Certified' },
  { id: 302, centerId: 'gilgit', category: 'Marketing',
    name: 'Digital Media Marketing', duration: '3 Months', fee: '5,000',
    level: 'Intermediate', icon: '📱', popular: true, certification: 'Government Certified' },
  { id: 303, centerId: 'gilgit', category: 'Design',
    name: 'Graphic Designing UI/UX', duration: '3 Months', fee: '3,500',
    level: 'Intermediate', icon: '🎨', popular: true, certification: 'Government Certified' },
  { id: 304, centerId: 'gilgit', category: 'Technical',
    name: 'CCTV Technician', duration: '3 Weeks', fee: '4,000',
    level: 'Beginner', icon: '📹', popular: false, certification: 'Government Certified' },

  // ============ PESHAWAR ============
  { id: 401, centerId: 'peshawar', category: 'Information Technology',
    name: 'Advance Certificate in IT (ACIT)', duration: '1 Year', fee: '6,000',
    level: 'Advanced', icon: '💻', popular: true, certification: 'Government Certified' },
  { id: 402, centerId: 'peshawar', category: 'Information Technology',
    name: 'Python Programming', duration: '6 Months', fee: '6,000',
    level: 'Intermediate', icon: '🐍', popular: true, certification: 'Government Certified' },
  { id: 403, centerId: 'peshawar', category: 'Networking',
    name: 'CISCO Certified Network Associate (CCNA)', duration: '3 Months',
    fee: '5,000', level: 'Intermediate', icon: '🌐', popular: true, certification: 'CISCO Certified' },
  { id: 404, centerId: 'peshawar', category: 'Electrical',
    name: 'Solar & UPS Technician', duration: '3 Months', fee: '6,000',
    level: 'Intermediate', icon: '☀️', popular: true, certification: 'Government Certified' },
  { id: 405, centerId: 'peshawar', category: 'Technical',
    name: 'Mobile Phone Repairing', duration: '3 Months', fee: '6,000',
    level: 'Beginner', icon: '📱', popular: false, certification: 'Government Certified' },

  // ============ KARACHI ============
  { id: 501, centerId: 'karachi', category: 'Information Technology',
    name: 'Web Development Course', duration: '3 Months', fee: '6,000',
    level: 'Intermediate', icon: '🌐', popular: true, certification: 'Government Certified' },
  { id: 502, centerId: 'karachi', category: 'Information Technology',
    name: 'Python Programming', duration: '6 Months', fee: '6,000',
    level: 'Intermediate', icon: '🐍', popular: true, certification: 'Government Certified' },
  { id: 503, centerId: 'karachi', category: 'Marketing',
    name: 'Digital Media Marketing', duration: '3 Months', fee: '5,000',
    level: 'Intermediate', icon: '📱', popular: true, certification: 'Government Certified' },
  { id: 504, centerId: 'karachi', category: 'Design',
    name: 'Graphic Designing UI/UX', duration: '3 Months', fee: '3,500',
    level: 'Intermediate', icon: '🎨', popular: false, certification: 'Government Certified' },
  { id: 505, centerId: 'karachi', category: 'Technical',
    name: 'CCTV Technician', duration: '3 Weeks', fee: '4,000',
    level: 'Beginner', icon: '📹', popular: false, certification: 'Government Certified' },
  { id: 506, centerId: 'karachi', category: 'Electrical',
    name: 'Solar & UPS Technician', duration: '3 Months', fee: '6,000',
    level: 'Intermediate', icon: '☀️', popular: true, certification: 'Government Certified' }
];

// ============================================================
// HELPERS
// ============================================================
export const getCoursesByCentre = (centerId) =>
  courseData.filter(c => c.centerId === centerId);

export const getCenterById = (centerId) =>
  centersData.find(c => c.id === centerId);

export const getCourseCountByCentre = (centerId) =>
  courseData.filter(c => c.centerId === centerId).length;

export const levels = ['All Levels', 'Beginner', 'Intermediate', 'Advanced'];

// ============================================================
// AI RECOMMENDATION ENGINE
// ============================================================
const interestMap = {
  programming: ['Information Technology', 'Networking'],
  design: ['Design', 'Designing (Mechanical)'],
  networking: ['Networking', 'Information Technology'],
  electrical: ['Electrical', 'Electrical & Electronics', 'Renewable Energy (Solar)'],
  marketing: ['Marketing', 'AI & Technology'],
  repair: ['Technical', 'Electrical', 'Mechanical Manufacturing'],
  solar: ['Electrical', 'Renewable Energy (Solar)'],
  web: ['Information Technology', 'AI & Technology'],
  mechanical: ['Designing (Mechanical)', 'Mechanical Manufacturing'],
  civil: ['Civil'],
  welding: ['Welding & Fabrication'],
  language: ['Language']
};

export const getAIRecommendations = (userInterests, userLevel, userGoal) => {
  let recs = [...courseData];

  if (userInterests && userInterests.length > 0) {
    const cats = userInterests.flatMap(i => interestMap[i] || []);
    if (cats.length > 0) recs = recs.filter(c => cats.includes(c.category));
  }
  if (userLevel && userLevel !== 'Any') recs = recs.filter(c => c.level === userLevel);
  if (userGoal === 'job' || userGoal === 'certification') {
    recs = recs.filter(c => c.certification === 'Government Certified');
  }
  if (recs.length === 0) recs = courseData.filter(c => c.popular).slice(0, 6);

  return recs
    .map(c => ({ ...c, score: (c.popular ? 3 : 0) + (c.certification ? 2 : 0) }))
    .sort((a, b) => b.score - a.score)
    .slice(0, 6);
};

export const getAIChatResponse = (query) => {
  const q = query.toLowerCase().trim();

  if (/^(hi|hello|hey|salam|assalam)/.test(q)) {
    return {
      type: 'greeting',
      message:
        "👋 Hi! I'm your AI Course Assistant.\n\nTry:\n• 'Show me IT courses'\n• 'What are short courses?'\n• 'Popular courses'\n• 'Where is the Quetta centre?'"
    };
  }

  if (
    q.includes('centre') || q.includes('center') || q.includes('location') ||
    q.includes('address') || q.includes('where') || q.includes('city')
  ) {
    return {
      type: 'centers',
      message: '📍 Here are our training centres across Pakistan:',
      centers: centersData
    };
  }

  const matched = courseData.filter(
    c =>
      c.name.toLowerCase().includes(q) ||
      c.category.toLowerCase().includes(q) ||
      (c.outline && c.outline.some(o => o.toLowerCase().includes(q)))
  );

  if (matched.length > 0) {
    return {
      type: 'course',
      message: `🎯 Found ${matched.length} course(s) matching "${query}":`,
      courses: matched.slice(0, 4)
    };
  }

  if (q.includes('short') || q.includes('fast')) {
    return {
      type: 'suggestion',
      message: '⚡ Shortest courses:',
      courses: courseData
        .filter(c => c.duration.includes('Week') || c.duration.includes('Weeks'))
        .slice(0, 4)
    };
  }

  if (q.includes('cheap') || q.includes('affordable') || q.includes('budget')) {
    return {
      type: 'suggestion',
      message: '💰 Most affordable courses:',
      courses: [...courseData]
        .sort((a, b) => parseInt(a.fee.replace(/,/g, '')) - parseInt(b.fee.replace(/,/g, '')))
        .slice(0, 4)
    };
  }

  if (q.includes('popular') || q.includes('best') || q.includes('recommend')) {
    return {
      type: 'suggestion',
      message: '⭐ Most popular courses:',
      courses: courseData.filter(c => c.popular).slice(0, 4)
    };
  }

  if (q.includes('government') || q.includes('certified')) {
    return {
      type: 'suggestion',
      message: '🎓 Government Certified courses:',
      courses: courseData.filter(c => c.certification === 'Government Certified').slice(0, 4)
    };
  }

  return {
    type: 'default',
    message:
      "🤔 Try:\n• 'Show me IT courses'\n• 'What are short courses?'\n• 'Recommend popular courses'\n• 'Where is the Quetta centre?'"
  };
};